import { Box, Typography } from '@mui/material';
import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { LineItem, Image } from 'components';

const CoinRateDetails = ({ coinRate }) => (
	<List>
		<LineItem label="Name" value={coinRate.name} />
		<LineItem label="Coins" value={coinRate.coins} />
		<LineItem label="XP" value={coinRate.xp} />
	</List>
);

export default CoinRateDetails;
